export default "__VITE_ASSET__BNBuYtMk__"